import Lesson from '@/models/Lesson';
import { TempLessonBlock } from '@/models/_deprecated/LessonBlock';
import { ListLessonBlocks } from './ListLessonBlocks';
import { ListLessons } from './ListLessons';
import CoursePath from '@/models/CoursePath';

export interface BaseListProps {
  course: CoursePath;
  updateLessons: () => Promise<void>;
  invalidateBlock?: (blockId: number) => Promise<void>;
  deleteLesson(lesson: Lesson): void;
  isLoadingLessonList: boolean;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  onReachEnd?(): unknown | Promise<unknown>;
}

type ListLessonsFactory = {
  lessonBlocksWithLessons: TempLessonBlock[];
  lessons: Lesson[];
} & BaseListProps;
const ListLessonsFactory = ({
  lessonBlocksWithLessons,
  lessons,
  ...props
}: ListLessonsFactory) => {
  if (lessonBlocksWithLessons.length)
    return (
      <ListLessonBlocks
        {...props}
        lessonBlocksWithLessons={lessonBlocksWithLessons}
      />
    );

  return <ListLessons {...props} lessons={lessons} />;
};

export default ListLessonsFactory;
